import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=13c4e43a&"
import script from "./Person.vue?vue&type=script&lang=js&"
export * from "./Person.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c4e43a')) {
      api.createRecord('13c4e43a', component.options)
    } else {
      api.reload('13c4e43a', component.options)
    }
    module.hot.accept("./Person.vue?vue&type=template&id=13c4e43a&", function () {
      api.rerender('13c4e43a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/people/Person.vue"
export default component.exports